/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import { IconButton } from '@picsio/ui';
import {
  ArrowBottomSmall,
  ArrowTopSmall,
  Close,
  AddMoreFilters,
  SearchPlusIcon,
} from '@picsio/icons';
import cn from 'classnames';
import ToolbarSort from '../../Sort';
import CatalogViewMode from '../../CatalogViewMode';
import SearchFilterItem from '../SearchFilterItem';
import picsioConfig from '../../../../../../config';
import { isRouteProducts } from '../../../helpers/history';
import Tooltip from '../../Tooltip';
import AddFiltersBtn from '../AddFiltersBtn';
import l10n from '../../../shared/strings';
import './styles.scss';

const SearchFiltersToriut = ({
  onlyTextSearch,
  customizingMode,
  containerRef,
  handleMouseEnter,
  handleMouseLeave,
  isHovering,
  hiddenItemsCount,
  isCollapsed,
  expand,
  collapse,
  controlsRef,
  resetIsHidden,
  hiddenItemsHaveActiveFilter,
  items,
  renderItems,
  handleResetAllFilters,
  handleCustomizingMode,
  handleSavedSearchSave,
  handleSelectFilter,
  handleConfirmFilter,
  handleResetFilter,
  handleOpen,
  handleClose,
  handleRemoveFilter,
  dragstart,
  dragenter,
  dragend,
  FILTERS,
  rootCollection,
  itemsMediaRef,
  itemsProductsRef,
  hiddenItemsCounterRef,
  sortType,
  handleChangeSort,
  handleShowAddFiltersDialog,
  isRouteSearch,
  location,
  selectedFilters,
  confirmedFilters,
  checkActive,
  checkOpen,
  renderItemsProducts,
}) => {
  // Helper function to get margin class based on state
  const getMarginClass = (isCustomizing, renderItemsList) => {
    if (isCustomizing && renderItemsList.length > 0) return 'toriut-search-filters__product-container--margin-small';
    if (!isCustomizing) return 'toriut-search-filters__product-container--margin-none';
    return 'toriut-search-filters__product-container--margin-large';
  };

  const showProductFilters = useMemo(() => {
    if (isCollapsed && hiddenItemsCount && !customizingMode && renderItems.length > 0) return false;
    return true;
  }, [isCollapsed, hiddenItemsCount, customizingMode, renderItems]);

  return (
    <div className="toriut-search-filters" ref={containerRef}>
      <If condition={!onlyTextSearch}>
        <div className="toriut-search-filters__media-section">
          <If condition={picsioConfig.isPim && renderItems.length > 0}>
            <If condition={customizingMode}>
              <div className="toriut-search-filters__media-divider toriut-search-filters__media-divider--customizing">
                {l10n.SEARCH.mediaFilters}
              </div>
            </If>
            <div
              className={cn('toriut-search-filters__media-container', {
                'toriut-search-filters__media-container--flex': customizingMode,
                'toriut-search-filters__media-container--inline': !customizingMode,
                'toriut-search-filters__media-container--has-products': renderItems.length > 0 && renderItemsProducts.length > 0,
                'toriut-search-filters__media-container--customizing': customizingMode,
              })}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <If condition={isHovering && hiddenItemsCount > 0}>
                <Tooltip placement="top" content={isCollapsed ? l10n.RESIZER.expandFilters : l10n.RESIZER.collapseFilters}>
                  <div className="toriut-search-filters__expand-control">
                    <Choose>
                      <When condition={isCollapsed}>
                        <IconButton onClick={(e) => expand(e, 'arrowHoverClick')}>
                          <ArrowBottomSmall />
                        </IconButton>
                      </When>
                      <Otherwise>
                        <IconButton onClick={collapse}>
                          <ArrowTopSmall />
                        </IconButton>
                      </Otherwise>
                    </Choose>
                  </div>
                </Tooltip>
              </If>
              <If condition={!customizingMode}>
                <div className="toriut-search-filters__controls" ref={controlsRef}>
                  <If condition={picsioConfig.isMainApp}>
                    <Choose>
                      <When condition={isCollapsed && !resetIsHidden}>
                        <Tooltip
                          content={l10n.SEARCH.resetFiltersBtn}
                          placement="top"
                        >
                          <IconButton
                            size="md"
                            className="toriut-search-filters__control-button toriut-search-filters__control-button--add-more"
                            onClick={(e) => handleResetAllFilters(e, 'minimizedView')}
                            color="primary"
                          >
                            <Close />
                          </IconButton>
                        </Tooltip>
                      </When>
                      <Otherwise>
                        <Tooltip
                          content={l10n.SEARCH.addMoreFilters}
                          placement="top"
                        >
                          <IconButton
                            size="md"
                            className="toriut-search-filters__control-button toriut-search-filters__control-button--add-more"
                            onClick={handleCustomizingMode}
                          >
                            <AddMoreFilters />
                          </IconButton>
                        </Tooltip>
                      </Otherwise>
                    </Choose>
                    <Tooltip
                      content={l10n.SEARCH.saveSearch}
                      placement="top"
                    >
                      <IconButton
                        size="md"
                        className="toriut-search-filters__control-button"
                        onClick={handleSavedSearchSave}
                        disabled={!Object.keys(selectedFilters).length}
                      >
                        <SearchPlusIcon />
                      </IconButton>
                    </Tooltip>
                  </If>
                  <If condition={isRouteSearch(location.path)}>
                    <Tooltip
                      content={l10n.SEARCH.sort}
                      placement="top"
                    >
                      <div>
                        <ToolbarSort
                          sortType={sortType}
                          changeSort={handleChangeSort}
                          openOnClick
                        />
                      </div>
                    </Tooltip>
                  </If>
                  <If condition={!isRouteProducts(location.pathname)}>
                    <Tooltip
                      content={l10n.SEARCH.view}
                      placement="top"
                    >
                      <div>
                        <CatalogViewMode openOnClick leftFilter />
                      </div>
                    </Tooltip>
                  </If>
                </div>
              </If>
              <div
                className="toriut-search-filters__drop-zone"
                data-id="first"
                onDragEnter={dragenter}
              />
              <If condition={!customizingMode && !isCollapsed && picsioConfig.isPim}>
                <div className="toriut-search-filters__media-divider">
                  {l10n.SEARCH.mediaFilters}
                </div>
              </If>
              <span />
              {
                (isCollapsed && hiddenItemsCount && !customizingMode ? items : renderItems).map((item, i) => (
                  <SearchFilterItem
                    key={item.id}
                    id={item.id}
                    data={item}
                    filterData={selectedFilters[item.id]}
                    confirmedData={confirmedFilters[item.id]}
                    customizingMode={customizingMode}
                    onSelectFilter={handleSelectFilter}
                    onConfirmFilter={handleConfirmFilter}
                    onResetFilter={handleResetFilter}
                    isSelected={checkActive(item.id)}
                    onOpen={handleOpen}
                    onClose={handleClose}
                    isOpen={checkOpen(item.id)}
                    onRemove={handleRemoveFilter}
                    onDragStart={dragstart}
                    onDragEnter={dragenter}
                    onDragEnd={dragend}
                    filters={FILTERS}
                    rootCollectionId={rootCollection?._id}
                    ref={itemsMediaRef.current[i]}
                  />
                ))
              }
              <If condition={isCollapsed && hiddenItemsCount && !customizingMode}>
                <Tooltip content={l10n.RESIZER.expandFilters} placement="top">
                  <div
                    ref={hiddenItemsCounterRef}
                    data-id="hiddenItems"
                    className="toriut-search-filters__hidden-counter"
                    onClick={(e) => expand(e, 'aggregatedBadgeClick')}
                  >
                    <div className={cn('toriut-search-filters__filter-item', {
                      'toriut-search-filters__filter-item--active': !hiddenItemsHaveActiveFilter,
                    })}
                    >
                      <div className="toriut-search-filters__filter-title">{`+${hiddenItemsCount}`}</div>
                    </div>
                  </div>
                </Tooltip>
              </If>
              <If condition={picsioConfig.isMainApp && renderItemsProducts.length === 0}>
                <If condition={customizingMode}>
                  <AddFiltersBtn onAddFilters={handleShowAddFiltersDialog} />
                </If>
              </If>
              <If condition={!customizingMode && Object.keys(confirmedFilters).length && !resetIsHidden && !isCollapsed && renderItemsProducts.length === 0}>
                <div
                  data-id="resetFilters"
                  className="toriut-search-filters__reset-link"
                >
                  <span
                    className="picsioLink"
                    onClick={(e) => handleResetAllFilters(e, 'expandedView')}
                  >
                    {l10n.SEARCH.resetFiltersBtn}
                  </span>
                </div>
              </If>
            </div>
          </If>
        </div>

        {/* products filters */}
        <If condition={showProductFilters}>
          <div className="toriut-search-filters__product-section">
            <If condition={picsioConfig.isPim && renderItemsProducts.length > 0}>
              <If condition={customizingMode}>
                <div className={cn('toriut-search-filters__product-divider toriut-search-filters__product-divider--customizing', {
                  'toriut-search-filters__product-divider--customizing--product-only': !renderItems || renderItems.length === 0,
                  'toriut-search-filters__product-divider--customizing--has-media': customizingMode && renderItems.length > 0,
                })}
                >
                  {l10n.SEARCH.productFilters}
                </div>
              </If>
              <div
                // ref={containerRef}
                className={cn('toriut-search-filters__product-container', {
                  'toriut-search-filters__product-container--flex': customizingMode,
                  'toriut-search-filters__product-container--inline': !customizingMode,
                  'toriut-search-filters__product-container--has-media': renderItemsProducts.length > 0 && renderItems.length > 0,
                  'toriut-search-filters__product-container--customizing': customizingMode,
                  [getMarginClass(customizingMode, renderItems)]: true,
                })}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <If condition={isHovering && hiddenItemsCount > 0 && renderItems.length === 0}>
                  <Tooltip placement="top" content={isCollapsed ? l10n.RESIZER.expandFilters : l10n.RESIZER.collapseFilters}>
                    <div className="toriut-search-filters__expand-control">
                      <Choose>
                        <When condition={isCollapsed}>
                          <IconButton onClick={(e) => expand(e, 'arrowHoverClick')}>
                            <ArrowBottomSmall />
                          </IconButton>
                        </When>
                        <Otherwise>
                          <IconButton onClick={collapse}>
                            <ArrowTopSmall />
                          </IconButton>
                        </Otherwise>
                      </Choose>
                    </div>
                  </Tooltip>
                </If>
                <If condition={!customizingMode && renderItems.length === 0}>
                  <div className="toriut-search-filters__controls" ref={controlsRef}>
                    <If condition={picsioConfig.isMainApp}>
                      <Choose>
                        <When condition={isCollapsed && !resetIsHidden}>
                          <Tooltip
                            content={l10n.SEARCH.resetFiltersBtn}
                            placement="top"
                          >
                            <IconButton
                              size="md"
                              className="toriut-search-filters__control-button toriut-search-filters__control-button--add-more"
                              onClick={(e) => handleResetAllFilters(e, 'minimizedView')}
                              color="primary"
                            >
                              <Close />
                            </IconButton>
                          </Tooltip>
                        </When>
                        <Otherwise>
                          <Tooltip
                            content={l10n.SEARCH.addMoreFilters}
                            placement="top"
                          >
                            <IconButton
                              size="md"
                              className="toriut-search-filters__control-button toriut-search-filters__control-button--add-more"
                              onClick={handleCustomizingMode}
                            >
                              <AddMoreFilters />
                            </IconButton>
                          </Tooltip>
                        </Otherwise>
                      </Choose>
                      <Tooltip
                        content={l10n.SEARCH.saveSearch}
                        placement="top"
                      >
                        <IconButton
                          size="md"
                          className="toriut-search-filters__control-button"
                          onClick={handleSavedSearchSave}
                          disabled={!Object.keys(selectedFilters).length}
                        >
                          <SearchPlusIcon />
                        </IconButton>
                      </Tooltip>
                    </If>
                    <If condition={isRouteSearch(location.path)}>
                      <Tooltip
                        content={l10n.SEARCH.sort}
                        placement="top"
                      >
                        <div>
                          <ToolbarSort
                            sortType={sortType}
                            changeSort={handleChangeSort}
                            openOnClick
                          />
                        </div>
                      </Tooltip>
                    </If>
                    <If condition={!isRouteProducts(location.pathname)}>
                      <Tooltip
                        content={l10n.SEARCH.view}
                        placement="top"
                      >
                        <div>
                          <CatalogViewMode openOnClick leftFilter />
                        </div>
                      </Tooltip>
                    </If>
                  </div>
                </If>
                <div
                  className={cn('toriut-search-filters__drop-zone', {
                    isAbsolute: renderItemsProducts.length > 0 && !customizingMode && renderItems.length > 0,
                  })}
                  data-id="first"
                  onDragEnter={dragenter}
                />
                <If condition={!customizingMode && !isCollapsed}>
                  <div className={cn('toriut-search-filters__product-divider', {
                    'toriut-search-filters__product-divider--standalone': !customizingMode && (!renderItems || renderItems.length === 0),
                  })}
                  >
                    {l10n.SEARCH.productFilters}
                  </div>
                </If>
                {
                  (isCollapsed && hiddenItemsCount && !customizingMode ? items : renderItemsProducts).map((item, i) => (
                    <SearchFilterItem
                      key={item.id}
                      id={item.id}
                      data={item}
                      filterData={selectedFilters[item.id]}
                      confirmedData={confirmedFilters[item.id]}
                      customizingMode={customizingMode}
                      onSelectFilter={handleSelectFilter}
                      onConfirmFilter={handleConfirmFilter}
                      onResetFilter={handleResetFilter}
                      isSelected={checkActive(item.id)}
                      onOpen={handleOpen}
                      onClose={handleClose}
                      isOpen={checkOpen(item.id)}
                      onRemove={handleRemoveFilter}
                      onDragStart={dragstart}
                      onDragEnter={dragenter}
                      onDragEnd={dragend}
                      filters={FILTERS}
                      rootCollectionId={rootCollection?._id}
                      ref={itemsProductsRef.current[i]}
                    />
                  ))
                }
                <If condition={isCollapsed && hiddenItemsCount && !customizingMode}>
                  <Tooltip content={l10n.RESIZER.expandFilters} placement="top">
                    <div
                      ref={hiddenItemsCounterRef}
                      data-id="hiddenItems"
                      className="toriut-search-filters__hidden-counter"
                      onClick={(e) => expand(e, 'aggregatedBadgeClick')}
                    >
                      <div className={cn('toriut-search-filters__filter-item', {
                        'toriut-search-filters__filter-item--active': !hiddenItemsHaveActiveFilter,
                      })}
                      >
                        <div className="toriut-search-filters__filter-title">{`+${hiddenItemsCount}`}</div>
                      </div>
                    </div>
                  </Tooltip>
                </If>
                <If condition={picsioConfig.isMainApp}>
                  <If condition={customizingMode}>
                    <AddFiltersBtn onAddFilters={handleShowAddFiltersDialog} />
                  </If>
                </If>
                <If condition={!customizingMode && Object.keys(confirmedFilters).length && !resetIsHidden && !isCollapsed}>
                  <div
                    data-id="resetFilters"
                    className="toriut-search-filters__reset-link"
                  >
                    <span
                      className="picsioLink"
                      onClick={(e) => handleResetAllFilters(e, 'expandedView')}
                    >
                      {l10n.SEARCH.resetFiltersBtn}
                    </span>
                  </div>
                </If>
              </div>
            </If>
          </div>
        </If>
      </If>
    </div>
  );
};

export default SearchFiltersToriut;
